import {
  Button,
  Flex,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { InfoOIcon } from '@tonic-one/react-icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { QuarantineApi } from '@Apis';
import { validateSpoUrl } from '../../../utils/common';
import {
  QuarantineSettingModalName,
  QuarantineSettingModalState,
} from './interface';

// enum QuarantineLocationTypeEnum {
//   EndUser = 0,
//   Admin = 1,
// }
// interface Setting {
//   type: QuarantineLocationTypeEnum;
//   siteURL: string;
// }

export function OneDriveQuarantineSettingModal({
  modal,
  setModal,
}: {
  modal: QuarantineSettingModalState;
  setModal: ({ name, todo }: QuarantineSettingModalState) => void;
}) {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const [siteURL, setSiteURL] = useState('');
  const [error, setError] = useState(false);

  // const [oneDriveSetting, setOneDriveSetting] = useState<Setting>({
  //   type: QuarantineLocationTypeEnum.EndUser,
  //   siteURL: '',
  // });`
  const onClose = () => {
    setModal({
      name: QuarantineSettingModalName.None,
      todo: null,
    });
  };

  useEffect(() => {
    if (!validateSpoUrl(siteURL)) {
      setError(true);
    } else {
      setError(false);
    }
  }, [siteURL]);

  const onClick = async () => {
    await QuarantineApi.apiPostOneDriveDedicatedQuarantineSetting();
  };

  const onVerify = async () => {
    await QuarantineApi.apiVerifyOneDriveDedicatedSiteURL('');
  };

  const onChange = (e: any) => {
    setSiteURL(e.target.value);
  };

  useEffect(() => {
    (async () => {
      if (modal.name === QuarantineSettingModalName.OneDrive) {
        await QuarantineApi.apiGetOneDriveDedicatedQuarantineSetting();
      }
    })();
  }, [modal.name]);

  return (
    <Modal
      closeOnEsc
      //closeOnOutsideClick
      isClosable
      isOpen={modal.name === QuarantineSettingModalName.OneDrive}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay />
      <ModalContent width={800}>
        <ModalHeader>{t('quarantine.modal.setting.title')}</ModalHeader>

        <ModalBody>
          <Text>{t('quarantine.modal.setting.location.title')}:</Text>
          <Flex direction="column" pl="30px" gap="4px" pt="8px">
            {/* end user */}
            <Radio>{t('quarantine.modal.setting.location.endUser.name')}</Radio>
            <Text pl="24px">
              {t('quarantine.modal.setting.location.endUser.descForSite')}
            </Text>
            <Space height="20px" />
            {/* admin */}
            <Radio>{t('quarantine.modal.setting.location.admin.name')}</Radio>
            <Text pl="24px">
              {t('quarantine.modal.setting.location.admin.descForSite')}
            </Text>

            <Flex align="center" pl="40px" gap="4px">
              <Text>{t('quarantine.modal.setting.label.siteURL')}</Text>
              <Text color="red">*</Text>:
              <Input
                value={siteURL}
                onChange={onChange}
                width="400px"
                onBlur={() => {
                  if (
                    !/^https/.test(siteURL.toLowerCase()) &&
                    /^http/.test(siteURL.toLowerCase())
                  ) {
                    setSiteURL(siteURL.replace(/^http/, 'https'));
                  }
                }}
              />
              <Button onClick={onVerify} variant="primary" disabled={error}>
                {t('common.action.label.verify')}
              </Button>
            </Flex>
          </Flex>
          <Flex gap="8px" align="center" pl="30px" pt="20px">
            <Icon as={InfoOIcon} color={colorStyle.color.info} />
            <Text fontSize="semibold">{t('common.label.note')}:</Text>
            <Text> {t('quarantine.modal.setting.note')}</Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" minWidth="20x" onClick={onClick}>
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
